<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="我的球杆"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <van-card
          shadow="never"
          class="my-card"
          v-for="club in clubList"
          :key="club.id">
        <template #desc>
          <!-- 序列号行：核心修改，包左对齐容器实现标签右对齐 -->
          <div class="info-item serial-item">
            <div class="label-value-wrap">
              <span class="label">球杆编码:</span>
              <span class="value value_xlh">{{ club.value }}</span>
            </div>
            <!-- 待绑定标签：单独右对齐 -->
            <van-tag class="bind-tag-red" v-if="club.bind ==='1'" >待绑定</van-tag>
            <van-tag class="bind-tag-green" v-else-if="club.bind ==='2'" >已绑定</van-tag>
            <van-tag class="bind-tag-green" v-else-if="club.bind ==='3'" >绑定失败</van-tag>
            <van-tag class="bind-tag-red" v-else>{{club.bind}}</van-tag>
          </div>
          <!-- 其他信息行：保持原有样式不变 -->
          <div class="info-item">
            <span class="label">品牌:</span>
            <span class="value value_xlh">{{ club.brand }}</span>
          </div>
          <div class="info-item">
            <span class="label">系列:</span>
            <span class="value value_xlh">{{ club.model }}</span>
          </div>
          <div class="info-item">
            <span class="label">商品名称:</span>
            <span class="value value_xlh">{{ club.portalSpecs }}</span>
          </div>
          <div class="info-item  serial-item">
            <div class="label-value-wrap">
              <span class="label">代理商:</span>
              <span class="value value_xlh">{{ club.agentName }}</span>
            </div>

            <!-- 待绑定标签：单独右对齐 -->
            <van-tag class="bind-tag" color="#D4AF37"  text-color="#000" v-if="club.bind ==='1'" @click="onBind(club.value )">去绑定</van-tag>
            <van-tag class="bind-tag" color="#D4AF37"  text-color="#000" v-if="club.bind ==='3'" @click="onBind(club.value )">重新绑定</van-tag>
          </div>
          <!-- 权益申请状态注释代码保持不变 -->
          <!--          <div class="info-item" v-if="club.businessId && (club.state == '1' || club.state == '2')">-->
          <!--            <span class="label">状态:</span>-->
          <!--            <span v-if="club.state == '1'" class="value value_xlh">{{ club.type=='1'?'置换':'翻新' }}审核中</span>-->
          <!--            <span v-if="club.state == '2'" class="value value_xlh">{{ club.type=='1'?'置换':'翻新' }}中</span>-->
          <!--          </div>-->
        </template>
      </van-card>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import {benefitsByUser} from "@/api/sales";
import {Dialog, Tag} from "vant";

export default {
  components: { VanTag: Tag },
  data(){
    return {
      clubList: [],
    }
  },
  created() {
    this.selectProductByUser();
  },
  methods: {
    //跳转球杆绑定
    onBind(number){
      this.$router.push({
        path: '/app_activation',
        query: {
          number: number
        }
      });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    selectProductByUser(){
      benefitsByUser().then(res => {
        if (res.code === 200) {
          if(res.data){
            this.clubList = res.data;
          }
        } else {
          Dialog.alert({
            title: '提示',
            message: res.returnMsg,
          });
        }
      }).catch(err => {
        Dialog.alert({
          title: '错误',
          message: '请稍后重试',
        });
      })
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;
}
::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;
}
.top-bar{
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
}
.container-item {
  margin-bottom: 60px;
}

.my-card{
  margin: 15px;
  border-radius: 12px;
  background: #fff;
  border: none;
  // 保证卡片内边距统一，标签对齐无偏移
  ::v-deep .van-card__desc {
    padding: 0 !important;
  }
}
.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 15px;
  width: 100%; // 撑满卡片宽度

  &:last-child {
    margin-bottom: 0;
  }

  .label {
    color: #0f0f0f;
    width: 80px;
  }

  .value {
    color: #0f0f0f;
    word-break: break-all;
  }
}

// 序列号行专属样式：两端对齐实现标签右对齐
.serial-item {
  justify-content: space-between; // 核心：左右两端对齐
  flex-wrap: nowrap; // 禁止换行，保证标签和序列号同行
}
.label-value-wrap {
  display: flex;
  align-items: center;
  flex-shrink: 1;
}
.bind-tag {
  font-size: 14px;
  line-height: 20px;
  padding: 2px 6px;
  margin-left: 10px;
  flex-shrink: 0;
}
.bind-tag-red{
  font-size: 10px;
  line-height: 15px;
  padding: 2px 6px;
  margin-left: 10px;
  flex-shrink: 0;
  background: #FFFFFF;
  color: red;
  border: 1px solid red;
  border-radius: 15px;
}
.bind-tag-green{
  font-size: 10px;
  line-height: 15px;
  padding: 2px 6px;
  margin-left: 10px;
  flex-shrink: 0;
  background: #FFFFFF;
  color: green;
  border: 1px solid green;
  border-radius: 15px;
}
</style>